export default {
  infoBlockContent: {
    id: 'bo_sellers_customer_care_automatic_refund_and_task_completion_info',
    defaultMessage:
      "Refund requests that aren't solved before the deadline will be automatically refunded within the next business day. Inactive requests will be completed after 28 days of inactivity.",
  },
  taskTotalCount: {
    id: 'bo_sellers_customer_care_open_tasks_total_task_count',
    defaultMessage: `{count, plural,
      one {# task}
      other {# tasks}
    }`,
  },
  noRequestFoundLinkLabel: {
    id: 'bo_sellers_customer_care_open_tasks_no_request_found_block_description',
    defaultMessage: 'See all requests',
  },
  previousTaskCompletedToastTitle: {
    id: 'asp_seller_conversation_all_tasks_success_toast',
    defaultMessage: 'Previous task complete. You’ve seen all your tasks.',
  },
  allTasksViewedToastTitle: {
    id: 'bo_sellers_customer_care_all_tasks_seen_success_toast',
    defaultMessage: 'Nice! You’ve seen all your tasks.',
  },

  returnDetailsButton: {
    id: 'bo_sellers_customer_care_open_tasks_return_details_button',
    defaultMessage: 'See return details',
  },
  returnDetailsOpenModalButton: {
    id: 'bo_sellers_customer_care_open_tasks_return_details_open_modal_button',
    defaultMessage: 'Learn how to see and export return details',
  },
  returnDetailsModalHeader: {
    id: 'bo_sellers_customer_care_open_tasks_return_details_modal_header',
    defaultMessage: 'See and export return details',
  },
  returnDetailsModalTitle: {
    id: 'bo_sellers_customer_care_open_tasks_return_details_modal_title',
    defaultMessage: 'Find your return details.',
  },
  returnDetailsModalDescription: {
    id: 'bo_sellers_customer_care_open_tasks_return_details_modal_description',
    defaultMessage:
      'Data on returned package arrival dates can easily be found in the Back Office.',
  },
  returnDetailsModalGuideStepOneFirstParagraph: {
    id: 'bo_sellers_customer_care_open_tasks_return_details_modal_guide_step_one_first_paragraph',
    defaultMessage:
      '{returndetailslink, html} to see all package arrival dates to your workshop from the past 30 days.',
  },
  returnDetailsModalGuideStepOneLinkLabel: {
    id: 'bo_sellers_customer_care_open_tasks_return_details_modal_guide_step_one_link_label',
    defaultMessage: 'Go to "Return details"',
  },
  returnDetailsModalGuideStepOneLinkValue: {
    id: 'bo_sellers_customer_care_open_tasks_return_details_modal_guide_step_one_link_value',
    defaultMessage:
      'https://www.backmarket.fr/bo_merchant/insights?tableau=customer-care&subview=details&view=Returns',
  },
  returnDetailsModalGuideStepOneSecondParagraph: {
    id: 'bo_sellers_customer_care_open_tasks_return_details_modal_guide_step_one_second_paragraph',
    defaultMessage:
      'You can also find it by going to “Insights” > “Customer Care” > “See return details”.',
  },
  returnDetailsModalGuideStepTwo: {
    id: 'bo_sellers_customer_care_open_tasks_return_details_modal_guide_step_two',
    defaultMessage:
      'On the right side of the screen, you’ll see “Return label status”. Choose “Delivered”.',
  },
  returnDetailsModalGuideStepThree: {
    id: 'bo_sellers_customer_care_open_tasks_return_details_modal_guide_step_three',
    defaultMessage:
      'To the left, you can export the data by selecting “Export as Excel or CSV”.',
  },
}
